import styled from 'styled-components';
import TextField from '@mui/material/TextField';

export const StyledTextField = styled(TextField)<{ $maxWidth?: string }>`
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth};
`;
